import { HttpHeaders } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { isPresent, Custom_RequestMethod } from './providers/common-service';
// import {isPresent} from 'ionic-angular/util/util';

/**
 * Created by Ashok on 06-04-2016.
 */

export class ContentType {
  public static URL_ENCODED_FORM_DATA: string = 'application/x-www-form-urlencoded';
  public static JSON: string = 'application/json';
  public static JAVASCRIPT: string = 'application/javascript';
  public static HTML: 'text/html';
  public static XML: 'application/xml';
  public static XHTML: 'application/xhtml+xml';
  public static PLAIN_TEXT = 'text/plain';
  public static JPEG = 'image/jpeg';
  public static PNG = 'image/png';
  public static WILDCARD_IMAGE = 'image/*';
  public static MULTIPART_FORM = 'multipart/form-data';
  public static QUERY = 'query';
}

export class RemoteRequest {
  ReqMethod = '';
  constructor(
    private url: string,
    private method: string,
    private reqContentType?: string,
    private data?: any,
    private headers?: any,
    private list = []
  ) {
    this.ReqMethod = this.method;
    this.reqContentType = this.reqContentType;
  }

  buildAjax(additionalHeaders?: any): any {
    let effUrl = this.url;
    // let headers = new Headers();
    let headers = new HttpHeaders();

    //Populate additional headers
    this.populateHeader(headers, additionalHeaders);
    //Now set the headers from the request
    this.populateHeader(headers, this.headers);

    let bodyStr: string = '';
    if (this.method === 'get' && isPresent(this.data)) {
      let paramStr = this.paramString(this.data);
      if (paramStr && paramStr.length) {
        effUrl += '?' + paramStr;
        this.list.push({
          key: 'Content-Type',
          value: ContentType.URL_ENCODED_FORM_DATA,
        });
      }
    } else if (this.method && this.method.toLowerCase().includes('put') && isPresent(this.data)) {
      console.debug('building for request ', this.method, this.reqContentType, ContentType.JSON, this.data);
      if (this.reqContentType === ContentType.JSON) {
        bodyStr = JSON.stringify(this.data);
        headers.set('Content-Type', ContentType.JSON);
        this.list.push({
          key: 'Content-Type',
          value: ContentType.JSON,
        });
      } else {
        let paramStr = this.paramString(this.data);
        if (paramStr && paramStr.length) {
          effUrl += '?' + paramStr;
          headers.set('Content-Type', 'text/html'); //ContentType.MULTIPART_FORM
        }
      }
    } else if (
      this.method?.toLowerCase().includes('delete') &&
      isPresent(this.data) &&
      (this.reqContentType === ContentType.HTML || this.reqContentType === ContentType.URL_ENCODED_FORM_DATA)
    ) {
      let paramStr = this.paramString(this.data);
      if (paramStr && paramStr.length) {
        effUrl += '?' + paramStr;
        headers.set('Content-Type', 'text/html'); //ContentType.MULTIPART_FORM
      }
    } else if (isPresent(this.data)) {
      if (ContentType.URL_ENCODED_FORM_DATA === this.reqContentType) {
        bodyStr = this.paramString(this.data);
        this.list.push({
          key: 'Content-Type',
          value: ContentType.URL_ENCODED_FORM_DATA,
        });
      } else if (ContentType.MULTIPART_FORM === this.reqContentType) {
        bodyStr = this.data; // this.paramString(this.data);
        //! for file, there is no need to set Content-Type, browser will handle
        // headers.set("enctype", ContentType.MULTIPART_FORM);
        // headers.set("Content-Type", ContentType.MULTIPART_FORM);
      } else {
        bodyStr = JSON.stringify(this.data);
        this.list.push({ key: 'Content-Type', value: ContentType.JSON });
      }
    } else
      this.list.push({
        key: 'Content-Type',
        value: ContentType.URL_ENCODED_FORM_DATA,
      });

    let args = {
      url: effUrl,
      headers: this.list,
      body: bodyStr,
    };
    // let req = new Request();
    // req.url = effUrl;
    // req.method = this.method;
    return args;
  }

  private paramString(data: any): string {
    let params = [];
    if (isPresent(data))
      for (let key in data) {
        let comp = encodeURIComponent(key);
        if (isPresent(data[key])) comp += '=' + encodeURIComponent(data[key]);
        params.push(comp);
      }

    return params.join('&');
  }

  /**
   * Populate the Headers instance with header attributes
   * @param hdr
   */
  private populateHeader(hdr: any, info: any) {
    if (isPresent(info)) for (let key in info) this.list.push({ key: key, value: info[key] });
  }
}
